import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import InvoiceItem from './InvoiceItem';
import InvoiceModal from './InvoiceModal';

const predefinedItems = [
  { name: 'Rice papadi (ચોખાની પાપડી)', price: '220' },
  { name: 'Corn papadi(મકાઈની પાપડી)', price: '250' },
  { name: 'sorghum papadi(જુવારની પાપડી)', price: '250' },
  { name: 'Greengarlic & rice papadi(લીલા લસણ અને ચોખાની પાપડી)', price: '300' },
  { name: 'Greengarlic & corn papadi(લીલા લસણ અને મકાઈની પાપડી)', price: '350' },
  { name: 'Greengarlic & sorghum papadi(લીલા લસણ અને જુવારની પાપડી)', price: '350' },
  { name: 'Rice -sev(ચોખાની સેવ)', price: '220' },
  { name: 'Rice-vadi(ચોખાની વડી)', price: '220' },
  { name: 'Plain Wafer (સાડી વેફર)', price: '400' },
  { name: 'Checks Wafer (ચેક્સ વેફર)', price: '500' },
  { name: 'Potato Shreds (બટાકા ની છીણ)', price: '400' },
  { name: 'Sago Chakdi (સાબુદાણા ચકડી)', price: '350' },
  { name: 'Sago Chakdi - Tomato Flavor (સાબુદાણા ચકડી (ટામેટાની))', price: '400' },
  { name: 'Sago Spoon (સાબુદાણા ચમચા)', price: '300' },
];


class InvoiceForm extends React.Component {
  constructor(props) {
    super(props);

    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];
    const storedInvoiceNumber = parseInt(localStorage.getItem('invoiceNumber'), 10) || 1;

    this.state = {
      isOpen: false,
      currency: '₹',
      invoiceNumber: storedInvoiceNumber,
      issueDate: formattedToday,
      dueDate: '',
      billTo: '',
      billFrom: '',
      notes: '',
      total: '0.00',
      subTotal: '0.00',
      taxRate: '',
      taxAmount: '0.00',
      discountRate: '',
      discountAmount: '0.00',
      deliveryRate: '',
      deliveryAmount: '0.00',
      additionalText: '',
      items: [{ id: 0, name: '', description: '', price: '1.00', quantity: 1 }],
    };
  }

  componentDidMount() {
    this.handleCalculateTotal();
    this.updateIssueDate();
  }

  updateIssueDate = () => {
    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];
    this.setState({ issueDate: formattedToday });
  };
  

  incrementInvoiceNumber = () => {
    this.setState(
      (prevState) => ({ invoiceNumber: prevState.invoiceNumber + 1 }),
      () => localStorage.setItem('invoiceNumber', this.state.invoiceNumber)
    );
  };

  handleRowDel = (itemToRemove) => {
    this.setState(
      (prevState) => ({ items: prevState.items.filter((item) => item.id !== itemToRemove.id) }),
      this.handleCalculateTotal
    );
  };

  handleAddEvent = () => {
    const newItem = {
      id: (+new Date() + Math.floor(Math.random() * 999999)).toString(36),
      name: '',
      description: '',
      price: '1.00',
      quantity: 1,
    };
    this.setState((prevState) => ({ items: [...prevState.items, newItem] }), this.handleCalculateTotal);
  };

  // handleCalculateTotal = () => {
  //   const { items, taxRate, discountRate, deliveryRate } = this.state;
  //   const subTotal = items.reduce((sum, item) => sum + parseFloat(item.price) * (parseInt(item.quantity, 10) || 0), 0);

  //   const discount = parseFloat(discountRate) || 0;
  //   const discountAmount = parseFloat(((subTotal * discount) / 100).toFixed(2));

  //   const tax = parseFloat(taxRate) || 0;
  //   const taxBase = subTotal - discountAmount;
  //   const taxAmount = parseFloat(((taxBase * tax) / 100).toFixed(2));

  //   const deliveryAmount = parseFloat(deliveryRate) || 0;

  //   const total = parseFloat((taxBase + taxAmount + deliveryAmount).toFixed(2));

  //   this.setState({
  //     subTotal: subTotal.toFixed(2),
  //     discountAmount: discountAmount.toFixed(2),
  //     taxAmount: taxAmount.toFixed(2),
  //     deliveryAmount: deliveryAmount.toFixed(3),
  //     total: total.toFixed(2),
  //   });
  // };
  handleCalculateTotal = () => {
    const { items, taxRate, discountRate, deliveryRate } = this.state;
    
    const subTotal = items.reduce((sum, item) => {
      let quantity = parseFloat(item.quantity) || 0;
      let price = parseFloat(item.price) || 0;
  
      return sum + (price * quantity);
    }, 0);
  
    const discount = parseFloat(discountRate) || 0;
    const discountAmount = parseFloat(((subTotal * discount) / 100).toFixed(2));
  
    const tax = parseFloat(taxRate) || 0;
    const taxBase = subTotal - discountAmount;
    const taxAmount = parseFloat(((taxBase * tax) / 100).toFixed(2));
  
    const deliveryAmount = parseFloat(deliveryRate) || 0;
    const total = parseFloat((taxBase + taxAmount + deliveryAmount).toFixed(2));
  
    this.setState({
      subTotal: subTotal.toFixed(2),
      discountAmount: discountAmount.toFixed(2),
      taxAmount: taxAmount.toFixed(2),
      deliveryAmount: deliveryAmount.toFixed(2),
      total: total.toFixed(2),
    });
  };
  
  
  

  onItemizedItemEdit = (evt, itemId) => {
    const { name, value } = evt.target;
    this.setState(
      (prevState) => ({
        items: prevState.items.map((item) => (item.id === itemId ? { ...item, [name]: value } : item)),
      }),
      this.handleCalculateTotal
    );
  };

  handleItemSelection = (itemId, selectedItemName) => {
    const selectedItem = predefinedItems.find((item) => item.name === selectedItemName);
    if (selectedItem) {
      this.setState(
        (prevState) => ({
          items: prevState.items.map((item) =>
            item.id === itemId ? { ...item, name: selectedItem.name, price: selectedItem.price } : item
          ),
        }),
        this.handleCalculateTotal
      );
    }
  };

  editField = (event) => {
    this.setState({ [event.target.name]: event.target.value }, this.handleCalculateTotal);
  };

  openModal = (event) => {
    event.preventDefault();
    this.handleCalculateTotal();
    this.incrementInvoiceNumber();
    this.updateIssueDate();
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  render() {
    return (
      <Form onSubmit={this.openModal} className="container-fluid">
        <Row className="g-3">
          <Col xs={12} md={8} lg={9} className="mx-auto">
            <Card className="p-4 my-3 shadow rounded-4">
              <Row className="mb-4 g-3 justify-content-between align-items-center">
                <Col xs={6}>
                  <h4 className="fw-bold">Invoice Form</h4>
                </Col>
                <Col xs={6} className="text-end">
                  <div className="fw-bold">Invoice : {this.state.invoiceNumber}</div>
                  <div className="fw-bold"> Date: {this.state.issueDate}</div>
                </Col>
              </Row>
              
              <Row className="mb-4 g-3">
                <Col xs={12} md={6}>
                  <Form.Label className="fw-bold">Bill to:</Form.Label>
                  <Form.Control placeholder="Enter recipient name" name="billTo" value={this.state.billTo} onChange={this.editField} required />
                </Col>
                <Col xs={12} md={6}>
                  <Form.Label className="fw-bold">Bill from:</Form.Label>
                  <Form.Control placeholder="Enter sender name" name="billFrom" value={this.state.billFrom} onChange={this.editField} required />
                </Col>
              </Row>

              <Row className="mb-4 g-3">
                <Col xs={12} md={6}>
                  <Form.Label className="fw-bold">Due Date:</Form.Label>
                  <Form.Control type="date" name="dueDate" value={this.state.dueDate} onChange={this.editField} required />
                </Col>
              </Row>

              {this.state.items.map((item) => (
                <Row key={item.id} className="align-items-center mb-3 g-3">
                  <Col xs={12} md={4}>
                    <Form.Label>Item</Form.Label>
                    <Form.Select value={item.name} onChange={(e) => this.handleItemSelection(item.id, e.target.value)} required>
                      <option value="">Select Item</option>
                      {predefinedItems.map((pItem) => (
                        <option key={pItem.name} value={pItem.name}>{pItem.name}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col xs={6} md={3}>
                    <Form.Label>Price</Form.Label>
                    <Form.Control type="text" value={`${this.state.currency}${item.price}`} readOnly />
                  </Col>
                  <Col xs={6} md={3}>
                    <Form.Label>Quantity</Form.Label>
                    <Form.Control type="number" step="0.01" min="0.25" value={item.quantity} name="quantity" onChange={(e) => this.onItemizedItemEdit(e, item.id)} required />
                  </Col>
                  <Col xs={12} md={2} className="d-grid">
                    <Button variant="danger" onClick={() => this.handleRowDel(item)}>Remove</Button>
                  </Col>
                </Row>
              ))}

              <Button variant="success" onClick={this.handleAddEvent} className="my-3 w-100">Add Item</Button>

              <Row className="mt-4 g-3">
                <Col xs={12} md={4}>
                  <Form.Label>Discount (%)</Form.Label>
                  <Form.Control type="number" step="0.01" name="discountRate" min="0" value={this.state.discountRate} onChange={this.editField} placeholder="Enter discount rate" />
                </Col>
                <Col xs={12} md={4}>
                  <Form.Label>Tax (%)</Form.Label>
                  <Form.Control type="number" step="0.01" name="taxRate" min="0" value={this.state.taxRate} onChange={this.editField} placeholder="Enter tax rate" />
                </Col>
                <Col xs={12} md={4}>
                  <Form.Label>Delivery Rate ({this.state.currency})</Form.Label>
                  <Form.Control type="number" step="0.01" name="deliveryRate" min="0" value={this.state.deliveryRate} onChange={this.editField} placeholder="Enter delivery Rate" />
                </Col>
              </Row>

              <Row className="mt-4 g-3">
                <Col xs={12}>
                  <Form.Label>Additional Notes</Form.Label>
                  <Form.Control as="textarea" name="additionalText" value={this.state.additionalText} onChange={this.editField} placeholder="Enter additional text or notes" rows={3} />
                </Col>
              </Row>

              <hr />

              <Row className="mt-4 justify-content-end g-3">
                <Col xs={12} md={8}>
                  <div className="d-flex justify-content-between">
                    <span className="fw-bold">Subtotal:</span>
                    <span>{this.state.currency}{this.state.subTotal}</span>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <span className="fw-bold">Discount ({this.state.discountRate || 0}%):</span>
                    <span>{this.state.currency}{this.state.discountAmount}</span>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <span className="fw-bold">Tax ({this.state.taxRate || 0}%):</span>
                    <span>{this.state.currency}{this.state.taxAmount}</span>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <span className="fw-bold">Delivery Rate :</span>
                    <span>{this.state.currency}{this.state.deliveryAmount}</span>
                  </div>
                  <hr />
                  <div className="d-flex justify-content-between" style={{ fontSize: '1.125rem' }}>
                    <span className="fw-bold">Total:</span>
                    <span className="fw-bold">{this.state.currency}{this.state.total}</span>
                  </div>
                </Col>
              </Row>

              <Button variant="primary" type="submit" className="w-100 mt-4">Review Invoice</Button>
            </Card>
          </Col>
        </Row>

        <InvoiceModal
          showModal={this.state.isOpen}
          closeModal={this.closeModal}
          info={this.state}
          items={this.state.items}
          currency={this.state.currency}
          subTotal={this.state.subTotal}
          taxAmount={this.state.taxAmount}
          discountAmount={this.state.discountAmount}
          deliveryAmount={this.state.deliveryAmount}
          total={this.state.total}
        />
      </Form>
    );
  }
}

export default InvoiceForm;
